import React from 'react'

import { Colors, Icon, ProgressBar, useMediaQueryContext } from '@fourthwall/components'
import { ArrowLongLeftIcon, ArrowLongRightIcon, BurgerIcon, CloseIcon } from '@fourthwall/icons'

import { RoundedButton } from '../RoundedButton/RoundedButton'
import * as S from './ContentHeader.styled'

type ContentHeaderProps = {
  title: string
  progressValue: number
  maxProgressValue: number
  onOpenDrawer: () => void
  onPrevious: () => void
  onNext: () => void
  onClose: () => void
}

export const ContentHeader = ({
  title,
  progressValue,
  maxProgressValue,
  onOpenDrawer,
  onPrevious,
  onNext,
  onClose,
}: ContentHeaderProps) => {
  const media = useMediaQueryContext()

  const renderContent = () => {
    if (!media.tablet) {
      return (
        <>
          <RoundedButton size="small" onClick={onOpenDrawer}>
            <Icon component={BurgerIcon} height={12} />
          </RoundedButton>
          <S.Title>{title}</S.Title>
          {progressValue < maxProgressValue && (
            <RoundedButton size="small" onClick={onNext}>
              <Icon component={ArrowLongRightIcon} height={12} />
            </RoundedButton>
          )}
        </>
      )
    }

    return (
      <>
        <S.Title>{title}</S.Title>
        <S.Actions>
          {progressValue > 1 && (
            <RoundedButton onClick={onPrevious}>
              <Icon component={ArrowLongLeftIcon} height={12} />
            </RoundedButton>
          )}
          {progressValue < maxProgressValue && (
            <RoundedButton onClick={onNext}>
              Next
              <Icon component={ArrowLongRightIcon} height={12} />
            </RoundedButton>
          )}
          {progressValue === maxProgressValue && (
            <RoundedButton onClick={onClose}>
              Close
              <Icon component={CloseIcon} height={12} />
            </RoundedButton>
          )}
        </S.Actions>
      </>
    )
  }

  return (
    <S.Container>
      <ProgressBar
        value={progressValue}
        max={maxProgressValue}
        height={media.tablet ? 6 : 4}
        barColor={Colors.G300}
      />
      <S.Content>{renderContent()}</S.Content>
    </S.Container>
  )
}
